import { TimeSelect } from '../../components/timeselect';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';

/** The main trip window.
 *
 */
export class TripWindow extends VisionWindow {
    layout!: dhtmlXLayoutObject;
    grid!: dhtmlXGridObject;
    paramForm!: dhtmlXForm; // Time selection form

    constructor(manager: VisionWindowManager) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.45;
        super(manager, {
            id: 'tracking_window',
            title: 'Tracking',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });
        this.window.setText('Tracking');

        this.buildUI();
        //this.buildEvents();
    }

    /** Build the UI elements for the window.
     *  Sets up the layout and attached the GUI elements to it.
     *
     */
    private buildUI(): void {
        this.layout = this.window.attachLayout('2U');
        // List of trips
        this.grid = this.layout.cells('b').attachGrid();
        this.grid.setHeader('Date, Start, Stop, Distance, Time, Idle, Track', '', [
            'text-align:left;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
        ]);
        this.grid.setColAlign('left,center,center,center,center,center,center');
        this.grid.init();

        //Form Parameters.
        const formData = JSON.parse(JSON.stringify(TimeSelect.FORM));
        formData.push({ type: 'button', value: 'Search', name: 'search' });

        this.paramForm = this.layout.cells('b').attachForm(formData);
        this.paramForm.getInput(TimeSelect.START).autocomplete = 'off';
    }

    public loadAsset(id: string): void {
        console.log('Load asset trips: ' + id);
    }
}
